import React from 'react';
import { container } from './container.css';
import { clsx } from 'clsx';

export type ContainerProps = React.HTMLAttributes<HTMLDivElement>;

export const Container = (props: ContainerProps) => {
  return <div {...props} className={clsx(container, props.className)} />;
};
